export default {
  translation: {
    common: {
      emailOrUsername: 'ایمیل یا نام کاربری',
      invalidEmailOrUsername: 'ایمیل یا نام کاربری نامعتبر است',
      invalidPassword: 'رمز عبور نامعتبر است',
      logInToPlanka: 'ورود به Planka',
      noInternetConnection: 'بدون اتصال به اینترنت',
      pageNotFound_title: 'صفحه یافت نشد',
      password: 'رمز عبور',
      projectManagement: 'مدیریت پروژه',
      serverConnectionFailed: 'اتصال به سرور ناموفق بود',
      unknownError: 'خطای ناشناخته، بعداً دوباره تلاش کنید',
      useSingleSignOn: 'استفاده از ورود یکپارچه',
    },

    action: {
      logIn: 'ورود',
      logInWithSSO: 'ورود با SSO',
    },
  },
};
